import React, { InputHTMLAttributes } from 'react';
import * as S from './Styles';

export type SelectItem = {
  id: number;
  name: string;
};

interface InputSelectProps extends InputHTMLAttributes<HTMLButtonElement> {
  value?: string;
  label?: string;
  items?: SelectItem[];
  onSelected?: (item: SelectItem) => void;
}

const InputSelect = ({
  value,
  label = 'Selecione',
  items = [],
  onSelected = () => {},
}: InputSelectProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const listRef = React.useRef<HTMLUListElement>(null);
  const buttonRef = React.useRef<HTMLButtonElement>(null);
  const handleSelected = (item: SelectItem) => {
    onSelected(item);
    setIsOpen(false);
  };
  const handleClickOutside = (e: any) => {
    if (
      listRef.current &&
      buttonRef.current &&
      !listRef.current.contains(e.target) &&
      !buttonRef.current.contains(e.target)
    ) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, []);

  return (
    <S.InputSelectContainer>
      <S.Button
        ref={buttonRef}
        onMouseUp={() => {
          setIsOpen(!isOpen);
        }}
        isActive={isOpen}
      >
        {label}
      </S.Button>
      {isOpen && (
        <S.List ref={listRef}>
          {items.map((item) => (
            <S.ListItem
              key={item.id}
              isSelected={item.name === value}
              onClick={() => handleSelected(item)}
            >
              {item.name}
            </S.ListItem>
          ))}
        </S.List>
      )}
    </S.InputSelectContainer>
  );
};

export default InputSelect;
